import { Sifarnik } from "../../model/FinancialInformationType";
import { MarketingConsentInformation } from "../../model/MarketingConsentType";

export const validateField = (
  field: string,
  value: Sifarnik[] | null,
  setFieldError: (field: string, message: (string | undefined)) => void,
): boolean => {
    let error: string | undefined = undefined;

    if (Array.isArray(value) && value.length === 0 || !value) {
        error = 'common.validation-error.required'
    }

    setFieldError(field, error);

    return error === undefined;
};

export const validateForm = (values: MarketingConsentInformation, setFieldError: (field: string, message: (string | undefined)) => void): boolean => {
    if (!values.privolaMarketinskeInformacije && !values.privolaPersonaliziranePonude) {
        return true;
    }
    return validateField('kanaliDostave', values.kanaliDostave, setFieldError);
};
